import { render, staticRenderFns } from "./TTBBelumAdaNota.vue?vue&type=template&id=1907222e&scoped=true&"
import script from "./TTBBelumAdaNota.vue?vue&type=script&lang=js&"
export * from "./TTBBelumAdaNota.vue?vue&type=script&lang=js&"
import style0 from "./TTBBelumAdaNota.vue?vue&type=style&index=0&id=1907222e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907222e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow})
